module.exports = __webpack_public_path__ + "img/9788957983348.9f424941.jpg";